import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfoCircleLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	id: "svg2",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { id: "defs2" }), /* @__PURE__ */ _jsx("path", {
		id: "path3",
		d: "m 12,7.5410156 c -0.4142,0 -0.75,0.3357804 -0.75,0.75 v 0.0625 c 0,0.4142096 0.3358,0.75 0.75,0.75 0.4142,0 0.75,-0.3357904 0.75,-0.75 v -0.0625 c 0,-0.4142196 -0.3358,-0.75 -0.75,-0.75 z m 0.0059,3.1035154 c -0.414199,0 -0.75,0.335801 -0.75,0.75 v 4.298828 c 0,0.4142 0.335801,0.75 0.75,0.75 0.4142,0 0.75,-0.3358 0.75,-0.75 v -4.298828 c 0,-0.414199 -0.3358,-0.75 -0.75,-0.75 z M 12,2.25 c -5.3851192,0 -9.75,4.3648808 -9.75,9.75 0,5.384089 4.3648208,9.75 9.75,9.75 5.385189,0 9.75,-4.365911 9.75,-9.75 0,-5.3851192 -4.364911,-9.75 -9.75,-9.75 z m 0,1.5 c 4.556691,0 8.25,3.6932991 8.25,8.25 0,4.555691 -3.693409,8.25 -8.25,8.25 C 7.4433591,20.25 3.75,16.555691 3.75,12 3.75,7.4432991 7.4432991,3.75 12,3.75 Z"
	})]
});
export default SvgInfoCircleLine;
